import { formatDate } from 'utils/date';

export const convertDataToPeriods = <T>(data: T[], pattern: string, groupKey: string): Record<string, T[]> => {
  if (!data.length) return {};

  return data.reduce<Record<string, T[]>>((prev, curr) => {
    // @ts-ignore TODO LATER FIX IMPLICIT ANY
    if (curr[groupKey]) {
      // @ts-ignore TODO LATER FIX IMPLICIT ANY
      const dateId = formatDate(curr[groupKey], pattern);
      return {
        ...prev,
        [dateId]: [...(prev[dateId] || []), curr],
      };
    }
    return prev;
  }, {});
};
